var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEyeIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 31.037,
    height: 16.094,
    viewBox: "0 0 31.037 16.094",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5716",
    "data-name": "Rectangle 5716",
    width: 31.037,
    height: 16.094,
    fill: "current"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_7257",
    "data-name": "Group 7257",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7246",
    "data-name": "Group 7246",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_17757",
    "data-name": "Path 17757",
    d: "M15.766,16.094A20.212,20.212,0,0,1,9.845,15.1a27.854,27.854,0,0,1-6.981-3.531A30.729,30.729,0,0,1,.1,9.363c-.119-.1-.126-.163-.028-.284a29.341,29.341,0,0,1,6.5-5.965A19.815,19.815,0,0,1,12.347.425,13.039,13.039,0,0,1,20.8,1.1,22.514,22.514,0,0,1,26.672,4.7a29.34,29.34,0,0,1,4,3.959c.5.594.508.6-.085,1.1a27.82,27.82,0,0,1-8.81,5.168,19.847,19.847,0,0,1-6.008,1.16M8.72,8.11a6.864,6.864,0,0,0,6.973,6.746,6.938,6.938,0,0,0,6.7-7.162A6.84,6.84,0,0,0,8.72,8.11",
    transform: "translate(0 0)",
    fill: "current"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17758",
    "data-name": "Path 17758",
    d: "M45.21,15.107a3.637,3.637,0,0,1,.123,1.908,4.431,4.431,0,1,1-5.4-5.063,6.155,6.155,0,0,1,2.015-.06c.061.005.14-.011.15.079s-.068.148-.135.2a2.2,2.2,0,0,0-.8,1.523,2.273,2.273,0,0,0,1.6,2.288,2.219,2.219,0,0,0,2.443-.877",
    transform: "translate(-25.408 -8.233)",
    fill: "current"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeIcon);
export default __webpack_public_path__ + "static/media/eye-icon.15b5439544fadaecc4ae00aa7619b607.svg";
export { ForwardRef as ReactComponent };